<template>
  <v-row class="flex-bar ma-0" :style="`z-index: ${$route.name.includes('Editor') ? '15' : '103'}`">
    <v-col class="pa-0">
      <Snowf
        v-if="isDecember() && !$store.state.View.is_printing_mode && $store.state.View.show_snowflakes"
        :amount="100"
        :size="3"
        :speed="2"
        :wind="4"
        :opacity="0.8"
        :swing="1"
        :image="null"
        :zIndex="null"
        :resize="true"
        color="#fff"
        />
      <v-row id="statistics-container" class="ma-0" :style="`width: calc((${project_length + 1} * (var(--workpackage_width) + 8px) + ${header_width}) * var(--taktplan_zoom))`">
        <div class="statistics-activator" id="statistics-activator">
          <slot name="statistics-activator"/>
        </div>
        <div class="statistics">
          <slot name="statistics"/>
        </div>
      </v-row>
      <v-row class="ma-0" :style="`width: calc((${project_length + 1} * (var(--workpackage_width) + 8px) + ${header_width}) * var(--taktplan_zoom))`">
        <slot name="header-columns-months"/>
      </v-row>
      <v-row class="ma-0" :style="`width: calc((${project_length + 1} * (var(--workpackage_width) + 8px) + ${header_width}) * var(--taktplan_zoom))`">
        <slot name="project-milestones"/>
      </v-row>
      <v-row class="ma-0" :style="`width: calc((${project_length + 1} * (var(--workpackage_width) + 8px) + ${header_width}) * var(--taktplan_zoom))`">
        <slot name="header-columns"/>
      </v-row>
    </v-col>
    </v-row>
</template>
<script>
import Snowf from 'vue-snowf';

export default {
  props: ['project_length', 'header_width', 'set_statistics_height'],
  components: {
    Snowf
  },
  data: () => ({
  }),
  methods: {
    isDecember(){
      if (new Date().getMonth() === 11) {
        return true;
      }
      return false;
    }
  }
}
</script>
<style>
  .flex-bar {
    position: sticky;
    position: -webkit-sticky;
    top: 0px;
  }
  .statistics-activator {
    position: fixed;
    left: 50%;
    top: calc(var(--statistics_height) + 53px);
    z-index: 104;
    transition: top 300ms ease-in-out;
  }
  .statistics {
    display: flex;
  }
</style>
